import React from "react";
import Artists from "../../components/Artists/Artists";
import NftMarquee from "../../components/NftMarquee/NftMarquee";
import AboutUsSection from "../../sections/AboutUs/AboutUsSection/AboutUsSection";
import SubscriptionSection from "../../sections/Home/SubscriptionSection/SubscriptionSection";
import GoldenStorySection from "../../sections/AboutUs/AboutUsSection/GoldenStorySection/GoldenStorySection";
import useScrollToTop from "../../utils/useScrollToTop";

const AboutUsPage = () => {
  useScrollToTop()
  return (
    <div>
      <AboutUsSection />
      <GoldenStorySection />
      <NftMarquee />
      <Artists />
      <SubscriptionSection margin={"mt-14"} />
    </div>
  );
};

export default AboutUsPage;
